import { Typography } from '@mui/material';

import CustomImageComponent from './custom/custom-image';

const ImageBox = ({
    name,
    image,
    width,
    height,
    onClick,
    hideText,
    styles,
    fontSize = 14,
    widthDiv,
    rounded,
    borderRadius,
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const getWidth = (value) => {
        if (rounded) {
            return (value ?? 40) * 0.75;
        }

        return value ?? 40;
    };

    return (
        <div className="image-box" onClick={handleClick} style={{ ...styles, width: widthDiv }}>
            {image && (
                <div
                    style={{
                        width: width ?? 40,
                        height: height ?? 40,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <CustomImageComponent
                        src={image}
                        alt={'imagen'}
                        width={getWidth(width)}
                        height={getWidth(height)}
                        className="image-box__image"
                        style={{ borderRadius: borderRadius ? borderRadius : rounded ? '50%' : '0%' }}
                    />
                </div>
            )}
            {!hideText && <Typography style={{ fontSize: fontSize }}>{name}</Typography>}
        </div>
    );
};

export default ImageBox;
